var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currency)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.animatedNumber,0)))]):_c('span',[_vm._v(_vm._s(_vm.animatedNumber))])}
var staticRenderFns = []

export { render, staticRenderFns }